import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getSwapInterestTypes, saveBatchSwapInterestTypes } from '../../api/swapInterestTypes';
import type { SwapInterestType } from '../../types/SwapInterestType';
import { t } from '../../i18n/t';

const columnDefs: ColDef<SwapInterestType>[] = [
  {
    field: 'swapInterestTypeId',
    headerName: t('swapInterestTypes.columns.swapInterestTypeId'),
    width: 140,
    cellDataType: 'number',
    editable: (p: EditableCallbackParams<SwapInterestType>) =>
      (p.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'swapInterestTypeName', headerName: t('swapInterestTypes.columns.swapInterestTypeName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<SwapInterestType> => ({ swapInterestTypeId: 0, swapInterestTypeName: '' });

export function SwapInterestTypesPage() {
  return (
    <LopCrudPage<SwapInterestType>
      resourceCode="swapInterestTypes"
      titleKey="swapInterestTypes.pageTitle"
      idField="swapInterestTypeId"
      getRows={getSwapInterestTypes}
      saveBatch={(added, modified, deletedIds) => saveBatchSwapInterestTypes(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
